<template>
    <el-dialog title="Add Part" :visible.sync="showDialog" @close="closeDialog" width="500px" class="part-dialog" append-to-body :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px" label-position="left">
            <el-form-item label="Part" prop="part">
                <service-ticket-part-selector ref="part-selector" :serviceCompanyId="currentCompanyId" :productId="productId" :isNotWarrantyClaim="isNotWarrantyClaim" @part-selected="partSelected"></service-ticket-part-selector>
            </el-form-item>          
            <el-form-item label="Quantity" prop="quantity">
                <el-input-number v-model="form.quantity" :min="1" :max="1000"></el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="primary" @click="addPart">Add</el-button>
            <el-button @click="closeDialog">Cancel</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import Vue from "vue";
    import ServiceTicketPartSelector from "./ServiceTicketPartSelector";
    import api from "../api";

    export default {
        name: "add-part-dialog",
        components: {
            ServiceTicketPartSelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            serviceCompanyId: {
                type: Number,
                required: false
            },
            productId: {
                required: true
            },
            isNotWarrantyClaim: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                form: {
                    part: undefined,
                    quantity: 1,

                    name: "",
                    price: undefined,
                    extendedPrice: undefined
                },
                rules: {
                    part: [
                        {
                            required: true,
                            message: "Please select part",
                            trigger: "change"
                        }
                    ],
                    name: [
                        {
                            required: true,
                            message: "Please enter name",
                            trigger: "blur"
                        }
                    ],
                    price: [
                        {
                            type: "number",
                            required: true,
                            message: "Please enter price",
                            trigger: "blur"
                        }
                    ],
                    extendedPrice: [
                        {
                            type: "number",
                            required: true,
                            message: "Please enter extended price",
                            trigger: "blur"
                        }
                    ],
                    quantity: [
                        {
                            type: "number",
                            required: true,
                            message: "Please enter quantity",
                            trigger: "blur"
                        }
                    ]
                },
                selectedPart: undefined,
                showDialog: this.visible
            };
        },
        methods: {
            closeDialog() {
                this.selectedPart = undefined;
                this.$refs["form"].resetFields();
                if (this.$refs["part-selector"]) {
                    this.$refs["part-selector"].reset();
                }
                this.showDialog = false;
                this.$emit("dialogClosed");
            },
            partSelected(part) {
                if (part) {
                    this.form.part = part;
                    var self = this;
                    api.getPartById(part.id, this.serviceCompanyId, this.isNotWarrantyClaim).then(function (response) {
                        self.form.part = response.data;
                        self.selectedPart = response.data;
                    });
                } else {
                    this.form.part = undefined;
                    this.form.quantity = 1;
                    this.selectedPart = undefined;
                }
            },
            addPart() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        var part = this.form.part;
                        if (this.misc) {
                            part = {
                                name: this.form.name,
                                price: this.form.price,
                                extendedPrice: this.form.extendedPrice
                            };
                        }
                        this.$emit("part-added", {
                            part: part,
                            quantity: this.form.quantity
                        });
                        this.closeDialog();
                    } else {
                        return false;
                    }
                });
            }
        },
        computed: {
            currentCompanyId() {
                return this.$isAdmin ? this.serviceCompanyId : window.currentCompany.id;
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        }
    };
</script>

<style scoped>
.full-width {
  width: 100%;
}

.part-dialog >>> .el-dialog__body {
  padding: 0 15px;
}
</style>


// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/AddPartDialog.vue